<div class="container-fluid">
    <app-pagetitle title="Subscription & Billing"
        [subtitle]="'Manage your subscription and billing details'"></app-pagetitle>

        <div class="page-content-wrapper">
        <div [class.loading-content]="loading">
            <app-loader [loading]="loading"></app-loader>

    <div class="row">
        <div class="col-lg-12 d-flex">
            <div class="card flex-fill border-0 shadow-sm">
                <div class="card-header">
                    <h5 class="fw-bold mb-0">
                        <i class="mdi mdi-crown me-2"></i>Current Plan
                    </h5>
                </div>
                <div class="card-body">
                    @if(loading){
                    <div class="text-center fw-bold py-5">
                        <div class="spinner-border spinner-border-sm mb-2" role="status"></div>
                        <div>Loading plan details...</div>
                    </div>
                    }
                    @if(!loading && hasPlanDetails){
                    <!-- Plan Header -->
                    <div class="row mb-4 pb-4 border-bottom">
                        <div class="col-lg-6">
                            <div class="mb-3">
                                <small class="text-muted fw-semibold text-uppercase">Plan Type</small>
                                <h3 class="fw-bold text-primary mt-1">{{planDetails.planName}}</h3>
                            </div>
                            <div>
                                <small class="text-muted fw-semibold text-uppercase">Monthly Price</small>
                                <div class="fw-bold fs-3 mt-1">₹<span class="text-primary">{{planDetails.price}}</span></div>
                            </div>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-between">
                            <div class="mb-3">
                                <small class="text-muted fw-semibold text-uppercase">Next Billing Date</small>
                                <div class="fw-bold fs-5 mt-1">
                                    <i class="mdi mdi-calendar-month me-2 text-primary"></i>
                                    {{ planDetails.endDate ? (planDetails.endDate | date: 'dd MMM yyyy') : '-' }}
                                </div>
                            </div>
                            <button class="btn btn-primary btn-sm align-self-start" 
                                [disabled]="customerOrders[0]?.status == 'Pending'"
                                (click)="openModal()">
                                <i class="mdi mdi-trending-up me-2"></i>Upgrade Plan
                            </button>
                        </div>
                    </div>

                    <!-- Usage Stats -->
                    <div class="row g-3">
                        <div class="col-md-6">
                            <div class="stat-card p-3 bg-dark bg-opacity-10 rounded">
                                <div class="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                        <small class="text-muted fw-semibold text-uppercase">Documents</small>
                                        <h5 class="fw-bold mb-0 mt-1">{{planDetails.documentsUsed}} / {{planDetails.documentsLimit}}</h5>
                                    </div>
                                    <i class="mdi mdi-file-document-multiple text-primary fs-5"></i>
                                </div>
                                <div class="progress" style="height: 6px;">
                                    <div class="progress-bar bg-primary" role="progressbar" 
                                        [style.width.%]="(planDetails.documentsUsed / planDetails.documentsLimit) * 100">
                                    </div>
                                </div>
                                <small class="text-muted d-block mt-2">
                                    {{((planDetails.documentsUsed / planDetails.documentsLimit) * 100) | number: '1.0-0'}}% used
                                </small>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="stat-card p-3 bg-dark bg-opacity-10 rounded">
                                <div class="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                        <small class="text-muted fw-semibold text-uppercase">Team Members</small>
                                        <h5 class="fw-bold mb-0 mt-1">{{planDetails.usersUsed}} / {{planDetails.usersLimit}}</h5>
                                    </div>
                                    <i class="mdi mdi-account-multiple text-primary fs-5"></i>
                                </div>
                                <div class="progress" style="height: 6px;">
                                    <div class="progress-bar bg-primary" role="progressbar" 
                                        [style.width.%]="(planDetails.usersUsed / planDetails.usersLimit) * 100">
                                    </div>
                                </div>
                                <small class="text-muted d-block mt-2">
                                    {{((planDetails.usersUsed / planDetails.usersLimit) * 100) | number: '1.0-0'}}% used
                                </small>
                            </div>
                        </div>
                    </div>
                    }
                    @if(!loading && !hasPlanDetails){
                    <div class="text-center py-5">
                        <i class="mdi mdi-database-off-outline text-muted" style="font-size: 2.5rem;"></i>
                        <p class="text-muted fw-semibold mt-2">No plan details available</p>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="row">
        <div class="col-lg-12 d-flex">
            <div class="card flex-fill">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <p class="fw-bold fs-5 mb-0">Plan Features</p>
                </div>
                <div class="card-body">
                    @if(loading){
                    <div class="text-center fw-bold">Loading data...</div>
                    }
                    @if(error){
                    <div class="alert alert-danger" role="alert">{{ error }}</div>
                    }
                    @if(!loading && isPlanFeatures){
                    <div class="row mb-3">
                        <div class="col-6 text-start">
                            <div class="label fw-semibold mb-2">Documents/Month</div>
                            <div class="value fw-bold fs-4">{{getPlanFeatures().documents}}</div>
                        </div>
                        <div class="col-6 text-start">
                            <div class="label fw-semibold mb-2">Team Members</div>
                            <div class="value fw-bold fs-4 mb-2">{{getPlanFeatures().users}}</div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-6 text-start">
                            @for(feature of getPlanFeatures().features; track feature;) {
                            <div class="fw-semibold mb-3">✔ {{feature}}</div>
                            }
                        </div>
                    </div>
                    }

                    @if(!loading && !isPlanFeatures){
                    <div class="text-center fw-bold">No data available.</div>
                    }
                </div>
            </div>
        </div>
    </div> -->

    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-header">
                    <app-filter searchPlaceholder="Invoice Number & Plan" [statusOptions]="statusOptions"
                        (filterChange)="onFilterChange($event)" searchHint="Invoice Number & Plan">
                    </app-filter>
                </div>
                <div class="card-body">

                    <p-table #dt [value]="customerOrders" [lazy]="true" (onLazyLoad)="getCustomerOrders($event)"
                        [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
                        [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll" styleClass="p-datatable-sm fs-6"
                        [showCurrentPageReport]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                        <ng-template pTemplate="header">
                            <tr>
                                <th>Plan</th>
                                <th>Invoice Number</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Invoice</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-order>
                            <tr>
                                <td>
                                    <div class="fw-semibold">{{ order.planName }}</div>
                                    <small class="text-muted">{{ order.notes }}</small>
                                </td>
                                <td>{{ order?.invoiceNumber || '-' }}</td>
                                
                                <td>
                                    ₹{{ order.amount | number }}
                                </td>
                                <td>
                                    <span class="badge rounded-pill px-3 p-2" [ngClass]="getStatusClass(order.status)">
                                        {{ order.status }}
                                    </span>
                                </td>
                                <td>{{ order.createdAt | date: 'dd MMM yyyy' }}</td>
                                <td>
                                    <button class="btn btn-sm btn-outline-primary py-0"
                                        [disabled]="order.status !== 'Completed'" (click)="downloadInvoice(order)"
                                        [ngbTooltip]="'Download Invoice'">
                                        <i class="mdi mdi-download fs-5"></i>
                                    </button>
                                </td>

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="9" class="text-center py-4 text-muted">
                                    <i class="mdi mdi-database-off-outline me-2"></i>
                                    No order found
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="row">
        <div class="col-lg-12">
            <div class="card flex-fill">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <p class="fw-bold fs-5 mb-0">Payment Method</p>
                </div>
                <div class="card-body">
                    @if(loading){
                    <div class="text-center fw-bold">Loading data...</div>
                    }
                    @if(error){
                    <div class="alert alert-danger" role="alert">{{ error }}</div>
                    }
                    @if(!loading && false){
                    <div class="row mb-3">
                        <div class="col-6 text-start">
                            <div class="label fw-semibold mb-2">Visa ending in 4242</div>
                            <div class="value">Expires 12/2026</div>
                        </div>
                        <div class="col-6 text-end">
                            <button class="btn btn-primary">Update</button>
                        </div>
                    </div>
                    }
                    @if(!loading && true){
                    <div class="text-center fw-bold">No data available.</div>
                    }
                </div>
            </div>
        </div>
    </div> -->

</div>

@if(showModal){
<div class="modal fade show d-block">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg rounded-4">

            <div class="modal-header border-0 pb-0 px-4 pt-4">
                <div>
                    <h5 class="modal-title fw-bold d-flex align-items-center">
                        <i class="mdi mdi-trending-up me-2 text-primary"></i>
                        Upgrade Plane
                    </h5>
                    <p class="text-muted small mb-0 mt-1">Choose a plan that fits your team and usage needs.</p>
                </div>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body px-4 py-4">
                <div class="row g-3">
                    <div class="col-12">
                        <label class="form-label fw-semibold text-dark">Available Plans</label>
                        <div class="d-grid gap-2">
                            @for(plan of plans; track plan;){
                            <button type="button"
                                class="list-group-item list-group-item-action border rounded-3 p-3 text-start d-flex justify-content-between align-items-center"
                                [class.border-primary]="selectedPlan?.name === plan.name"
                                [class.bg-primary-subtle]="selectedPlan?.name === plan.name"
                                (click)="selectPlan(plan)">
                                <div>
                                    <div class="fw-semibold">{{ plan.name }}</div>
                                    <small class="text-muted">Flexible plan for growing teams</small>
                                </div>
                                <strong class="text-primary">₹{{ plan.price }}</strong>
                            </button>
                            }
                        </div>

                        <div class="mt-3" *ngIf="selectedPlan.name">
                            <div class="alert alert-info mb-0 rounded-3 border-0">
                                <div class="row g-2">
                                    <div class="col-md-6">
                                        <div class="fw-semibold mb-1">Selected Plan</div>
                                        <div>{{ selectedPlan.name }}</div>
                                        <div class="fw-semibold mt-2">Price: ₹{{ selectedPlan.price }}</div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="fw-semibold mb-1">Included Limits</div>
                                        <div>Users: {{ selectedPlan.users }}</div>
                                        <div>Documents: {{ selectedPlan.documents }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-12">
                        <label class="form-label fw-semibold">
                            Payment Mode <span class="text-danger">*</span>
                        </label>
                        <div class="d-flex flex-wrap gap-2">
                            <div *ngFor="let payment of paymentMethod" class="form-check border rounded-3 px-3 py-2">
                                <input class="form-check-input" type="radio" name="payment" [id]="payment" [value]="payment"
                                    [(ngModel)]="selectedPaymentMode" [disabled]="payment === 'Online'" />
                                <label class="form-check-label ms-2" [for]="payment">
                                    {{ payment }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-12">
                        <label for="planNote" class="form-label fw-semibold">
                            Note
                        </label>
                        <input type="text" class="form-control rounded-3" name="planNote" id="planNote" [(ngModel)]="planNote"
                            placeholder="Enter note" />
                    </div>
                </div>
            </div>

            <div class="modal-footer border-0 px-4 pb-4">
                <button class="btn btn-primary w-100 py-2 fw-semibold" type="button" (click)="upgradePlan()" [disabled]="!isEnable">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                    {{ loading ? 'Loading...' : 'Submit' }}
                </button>
            </div>

        </div>
    </div>
</div>
}

@if(showModal){
<div class="modal-backdrop fade show"></div>
}
